(function () {
    'use strict';

    function AnalogClockController($uibModal, $scope, $state, ParseLinks, AlertService, paginationConstants, translate, translatePartialLoader, ReportService) {

    };
    var AnalogClockController = {

        templateUrl: 'app/dashboard/analogClock/analogClock.template.html',
        controller: AnalogClockController,
        bindings:
            {
                date: '=?',
            }

    };
    angular
        .module('tikonApp')
        .component('analogClock', AnalogClockController);

    AnalogClockController.$inject = ['$uibModal', '$scope', '$state', 'ParseLinks', 'AlertService', 'paginationConstants', '$translate', '$translatePartialLoader', 'ReportService'];


})();
